// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const hakamo_o: PokeData = {
  "id": 783,
  "name": "hakamo-o",
  "height": 12,
  "weight": 470,
  "base_experience": 147,
  "types": [
    PokeType.DRAGON,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "leer",
    "screech",
    "bide",
    "protect",
    "scary-face",
    "outrage",
    "sky-uppercut",
    "iron-defense",
    "dragon-claw",
    "dragon-dance",
    "close-combat",
    "autotomize",
    "dragon-tail",
    "work-up",
    "noble-roar"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "leer",
    "protect",
    "scary-face",
    "outrage",
    "dragon-claw",
    "dragon-dance",
    "close-combat",
    "bulk-up",
    "meteor-assault",
    "superpower",
    "jump-kick"
  ],
  "evolution_chain": {
    "id": 408,
    "item": null,
    "species": [
      {
        "name": "jangmo-o",
        "order": 782,
        "types": [
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "hakamo-o",
        "order": 783,
        "types": [
          PokeType.DRAGON,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 782,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "kommo-o",
        "order": 784,
        "types": [
          PokeType.DRAGON,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 783,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 45,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 67.5,
    "speed": 65,
    "ability_power": 75
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
